export const MIX_PANEL_EVENTS = {
  PAGE_VISIT: "PAGE_VISIT",
  SIGN_UP_SUCCESS: "SIGN_UP_SUCCESS",
  SIGN_UP_FAILED: "SIGN_UP_FAILED",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  GOOGLE_LOGIN: "GOOGLE_LOGIN",
  PASSWORD_RESET: "PASSWORD_RESET",
  ACCOUNT_DELETION: "ACCOUNT_DELETION",
  SETTINGS_UPDATE: "SETTINGS_UPDATE",
  BILLING_UPDATE: "BILLING_UPDATE",
  VERIFY_FAILED: "VERIFY_FAILED",
  WHATSAPP_SUPPORT_CLICKED: "WHATSAPP_SUPPORT_CLICKED",
  OPEN_DEMO_LINK: "OPEN_DEMO_LINK",
  OPEN_PORTAL: "OPEN_PORTAL",
  DELETE_PORTAL: "DELETE_PORTAL",
};